import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import { SketchPicker } from 'react-color'
import InputField from './Input/Input'
import ReactDOM from 'react-dom'
import TetherComponent from 'react-tether'

export class Input extends Component {
  static propTypes = {
    value: PropTypes.string,
    onChange: PropTypes.func,
    className: PropTypes.string,
    label: PropTypes.string
  }

  constructor (props) {
    super(props)

    this.state = {
      isOpen: false,
      editValue: props.value || props.data,
      isLookupOpened: false
    }

    this.dropdown = React.createRef()
  }

  handleClick = (e) => {
    const { isOpen, isLookupOpened } = this.state
    const node = ReactDOM.findDOMNode(this)
    const dropdown = ReactDOM.findDOMNode(this.dropdown && this.dropdown.current)
    if (!(node && node.contains(e.target)) &&
        !(dropdown && dropdown.contains(e.target)) &&
        isOpen &&
        !isLookupOpened) {
      this.setState({ isOpen: false })
    }
  }

  componentDidMount = () => {
    document.addEventListener('mousedown', this.handleClick, false)
  }

  componentWillUnmount = () => {
    document.removeEventListener('mousedown', this.handleClick, false)
  }

  static getDerivedStateFromProps (nextProps, prevState) {
    const value = nextProps.value || nextProps.data
    if (value !== prevState.editValue) {
      return {
        editValue: value
      }
    }
    return null
  }

  onInputChange = (e) => {
    const { value } = e.target
    this.setState({
      editValue: value
    })
  }

  onBlur = () => {
    const { editValue } = this.state
    this.setState({
      isOpen: false
    })
    this.props.onValueChange && this.props.onValueChange(editValue)
  }

  onKeyDown = (e) => {
    const { value } = e.target
    if (e.keyCode === 13) {
      this.setState({
        isOpen: false
      })
      this.props.onValueChange && this.props.onValueChange(value)
    }
  }

  onInputClick = () => {
    this.setState({ isOpen: !this.state.isOpen })
  }

  onColorChange = (color) => {
    this.setState({
      editValue: color.hex
    })
    this.props.onValueChange && this.props.onValueChange(color.hex)
  }

  clearValue = () => {
    this.setState({
      isOpen: false,
      editValue: ''
    })
    this.props.onValueChange && this.props.onValueChange('')
  }

  render () {
    const {
      value,
      className,
      label,
      autoFocus,
      placeholder,
      required,
      helpText,
      helpTextTools,
      labelStyle
    } = this.props
    const { isOpen, editValue } = this.state
    const isValid = !required || (required && editValue) || (required && value)
    return (
      <Fragment>
        <TetherComponent
          style={{ zIndex: 999999 }}
          attachment='top right'
          targetAttachment='bottom right'
          renderTarget={ref => (
            <div ref={ref}>
              <InputField
                value={editValue || ''}
                onBlur={this.onBlur}
                onChange={this.onInputChange}
                error={this.props.error || !isValid}
                className={className}
                label={label || ''}
                placeholder={placeholder}
                onKeyDown={this.onKeyDown}
                required={required}
                helpText={helpText}
                helpTextTools={helpTextTools}
                labelStyle={labelStyle}
                rightItem={<PickerTrigger onClick={this.onInputClick} color={editValue} />}
                {... editValue && { icon: 'close' }}
              {... editValue && { onIconClick: this.clearValue }}
                autoFocus={autoFocus}
              />
            </div>
          )}
          renderElement={ref => isOpen && (
            <div ref={ref}>
              <div className={'dropdown'} ref={this.dropdown}>
                <div style={{ display: 'inline-table' }}>
                  <SketchPicker
                    color={editValue || '#fff'}
                    width={250}
                    onChange={this.onColorChange}
                  />
                </div>
              </div>
            </div>)}
        />
        <style jsx>{`
          .dropdown {
            z-index: 1000001;
            margin-top: 0.5rem;
            background: #fff;
            border: 1px solid #ececee;
            border-radius: 4px;
            box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.1);
          }
          .has_no_error select, .has_no_error input {
            border-color: #d8dde6 !important;
            background-color: #fff !important;
            box-shadow: none !important;
          }
          .portal_modal {
            position: fixed;
            top: 3rem;
            z-index: 10;
          }
          `}</style>
      </Fragment>
    )
  }
}

export const Output = props => {
  const data = props.data || props.value
  return <div style={{ width: '12px', height: '12px', background: data || 'transparent' }} />
}

const PickerTrigger = (props) => {
  const { color, onClick } = props
  return (
    <>
      <div onClick={onClick} />
      <style jsx>{`
        width: 20px;
        height: 20px;
        background: ${color || '#fff'};
        border: 1px solid #ced4da;
        border-radius: 2px;
        `}</style>
    </>
  )
}
